(() => {
  const pending = new WeakMap();
  const revoke = (scope) => {
    if (!scope) return;
    scope.querySelectorAll('[data-en-reference-approved]').forEach((element) => {
      element.removeAttribute('data-en-reference-approved');
    });
  };
  const scopeFor = (target) => {
    if (!target || typeof target.closest !== 'function') return null;
    let scope = target.closest('.hdt-product-info__list, hdt-card-product, #hdt-quick-view-modal, #hdt-quick-add-modal');
    if (!scope) {
      const section = target.closest('.shopify-section');
      const infos = section?.querySelectorAll('.hdt-product-info__list');
      if (infos?.length === 1) scope = infos[0];
      else if (section?.querySelectorAll('.hdt-price-wrapp').length === 1) scope = section;
    }
    return scope || target;
  };
  const approvedTemplate = (wrapper, variant) => {
    const map = wrapper.querySelector('[data-en-reference-map]');
    if (!map || !variant || variant.id == null) return null;
    const template = [...map.querySelectorAll('template[data-en-reference-variant-id]')]
      .find((item) => item.dataset.enReferenceVariantId === String(variant.id));
    if (!template) return null;
    const data = template.dataset;
    const price = Number(variant.price);
    const approvedPrice = Number(data.enPriceCents);
    const reference = Number(data.enReferenceCents);
    const saving = Number(data.enSavingCents);
    const percent = Number(data.enSavingPercent);
    if (![price, approvedPrice, reference, saving, percent].every(Number.isSafeInteger)) return null;
    if (price !== approvedPrice || reference <= price || saving !== reference - price) return null;
    if (percent !== Math.floor((saving * 100) / reference)) return null;
    if (variant.product_id != null && String(variant.product_id) !== map.dataset.enProductId) return null;
    if (map.dataset.enMarket !== 'US' || map.dataset.enCurrency !== 'USD') return null;
    if (data.enMarket !== map.dataset.enMarket || data.enCurrency !== map.dataset.enCurrency) return null;
    if (!data.enPriceVersion || !data.enApprovalVersion) return null;
    if (data.enBasis !== 'HISTORY' && data.enBasis !== 'MSRP') return null;
    if (!/^\d{4}-\d{2}-\d{2}$/.test(data.enValidUntil || '')) return null;
    if (data.enValidUntil < new Date().toISOString().slice(0, 10)) return null;
    const content = template.content;
    const currentText = content.querySelector('[data-en-current-price]')?.textContent?.trim();
    const referenceText = content.querySelector('[data-en-reference-price]')?.textContent?.trim();
    const savingText = content.querySelector('[data-en-saving]')?.textContent?.trim();
    const currentLabel = content.querySelector('[data-en-current-label]')?.textContent?.trim();
    const referenceLabel = content.querySelector('[data-en-reference-label]')?.textContent?.trim();
    if (!currentText || !referenceText || !savingText || !currentLabel || !referenceLabel) return null;
    return { data, currentText, referenceText, savingText, currentLabel, referenceLabel };
  };
  const apply = (scope, variant) => {
    if (!scope || !variant) return;
    scope.querySelectorAll('.hdt-price-wrapp').forEach((wrapper) => {
      const approved = approvedTemplate(wrapper, variant);
      const list = wrapper.querySelector('.hdt-price__sale:not([hidden])')
        || wrapper.querySelector('.hdt-price__list:not([hidden])')
        || wrapper.querySelector('.hdt-price__sale')
        || wrapper.querySelector('.hdt-price__list');
      const current = list?.querySelector('hdt-price');
      if (!approved) {
        current?.classList.remove('hdt-price-on-sale');
        return;
      }
      const currentMoney = current?.querySelector('.hdt-money');
      if (!currentMoney) return;
      let compare = list.querySelector('hdt-compare-at-price');
      if (!compare) {
        compare = document.createElement('hdt-compare-at-price');
        compare.className = 'hdt-compare-at-price';
        list.insertBefore(compare, current);
      }
      let compareLabel = compare.querySelector('.sr-only');
      if (!compareLabel) {
        compareLabel = document.createElement('span');
        compareLabel.className = 'sr-only sr-only--inline';
        compare.append(compareLabel);
      }
      let compareMoney = compare.querySelector('.hdt-money');
      if (!compareMoney) {
        compareMoney = document.createElement('span');
        compareMoney.className = 'hdt-money';
        compare.append(compareMoney);
      }
      let saving = wrapper.querySelector('.en-reference-saving');
      if (!saving) {
        saving = document.createElement('span');
        saving.className = 'en-reference-saving';
        (wrapper.querySelector('.hdt-price__container') || list).append(saving);
      }
      currentMoney.textContent = approved.currentText;
      current.classList.toggle('hdt-price-on-sale', approved.data.enBasis === 'HISTORY');
      const currentLabel = current.querySelector('.sr-only');
      if (currentLabel) currentLabel.textContent = approved.currentLabel;
      compareLabel.textContent = approved.referenceLabel;
      compareMoney.textContent = approved.referenceText;
      saving.textContent = approved.savingText;
      saving.dataset.enReferenceBasis = approved.data.enBasis;
      compare.hidden = false;
      compare.classList.remove('hdt-hidden');
      compare.setAttribute('data-en-reference-approved', '');
      saving.setAttribute('data-en-reference-approved', '');
    });
  };
  const schedule = (scope, variant) => {
    if (!scope) return;
    const ticket = {};
    pending.set(scope, ticket);
    requestAnimationFrame(() => {
      if (pending.get(scope) === ticket) apply(scope, variant);
    });
  };
  document.addEventListener('variant:change', (event) => {
    const scope = scopeFor(event.target);
    revoke(scope);
    schedule(scope, event.detail?.variant);
  }, true);
  document.addEventListener('click', (event) => {
    const swatch = event.target?.closest?.('hdt-swatch-card');
    if (swatch) revoke(swatch.closest('hdt-card-product'));
  }, true);
  document.addEventListener('variant:updated', (event) => {
    const card = event.target?.closest?.('hdt-card-product');
    if (card) schedule(card, event.detail?.variant);
  });
})();
